import React, {useEffect} from 'react'
import {Image, Rect, Transformer} from "react-konva";
import useImage from "use-image";
import {parseInt} from "lodash";
import {BLOCK_SNAP_SIZE} from "../../../constants/design.constant";

const BackgroundImageItem = ({
                                 backgroundImage,
                                 settings,
                                 stageHeight,
                                 stageWidth,
                             }) => {
    const [image] = useImage(backgroundImage.src, 'anonymous');
    const shapeRef = React.useRef();

    return (
        <>
            {backgroundImage?.isRepeatImage && !backgroundImage?.isBackgroundImage && image &&
                <Rect
                    ref={shapeRef}
                    x={0}
                    y={0}
                    width={stageWidth}
                    height={stageHeight}
                    fillPatternImage={image}
                    fillPatternRepeat={'repeat'}
                    fillPatternRotation={backgroundImage?.fillPatternRotation}
                    fillPatternOffsetX={backgroundImage?.fillPatternOffsetX}
                    fillPatternOffsetY={backgroundImage?.fillPatternOffsetY}
                    fillPatternScaleY={backgroundImage?.height / backgroundImage?.imageHeight}
                    fillPatternScaleX={backgroundImage?.height / backgroundImage?.imageHeight}
                    listening={false}/>
            }

            {backgroundImage?.isTemplate && image &&
                <Rect
                    name={'template-image'}
                    ref={shapeRef}
                    x={0}
                    y={0}
                    width={stageWidth}
                    height={stageHeight}
                    fillPatternImage={image}
                    fillPatternRepeat={'no-repeat'}
                    fillPatternRotation={backgroundImage?.fillPatternRotation}
                    fillPatternOffsetX={backgroundImage?.fillPatternOffsetX}
                    fillPatternOffsetY={backgroundImage?.fillPatternOffsetY}
                    fillPatternScaleX={2}
                    fillPatternScaleY={2}
                    opacity={backgroundImage?.opacity / 100}
                    listening={false}/>
            }

            {backgroundImage?.isBackgroundImage && !backgroundImage?.isTemplate &&

                <Rect
                    name={'variant-image'}
                    ref={shapeRef}
                    x={backgroundImage.x}
                    y={backgroundImage.y}
                    width={settings?.width}
                    height={settings?.height}
                    fillPatternImage={image}
                    fillPatternRepeat={backgroundImage?.fillPatternRepeat}
                    fillPatternRotation={backgroundImage?.fillPatternRotation}
                    fillPatternOffsetX={backgroundImage?.fillPatternOffsetX}
                    fillPatternOffsetY={backgroundImage?.fillPatternOffsetY}
                    fillPatternScaleX={backgroundImage?.fillPatternScaleX}
                    fillPatternScaleY={backgroundImage?.fillPatternScaleY}
                    listening={false}/>
            }
        </>
    )
}

export default BackgroundImageItem
